export enum VatRateEnum {
  Zero = 0,
  Six = 6,
  Twelve = 12,
  TwentyFive = 25,
}
